import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { editEvaluation, getClassStudents, deleteEvaluation, resetEvaluationStatus } from '../../../../redux';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Link, useNavigate } from 'react-router-dom';
import '../index.css'
import StickyWrapper from '../../../Components/StickySaveButton';


// A student may submit (and therefore edit/delete) a review up until midnight
// (12:00am local time) at the end of the assignment's due date. This mirrors
// the on-time check used elsewhere (e.g. SubmittedEvaluations / the match
// route): the due date is floored to the start of its day, then one day is
// added to reach the end-of-day cutoff. Computed in the browser's local
// timezone so it matches the student's local cutoff.
const calculateIfOnTime = (dueDate) => {
    if (!dueDate) return false;
    const assignmentDueDate = new Date(dueDate);
    const currentDateObject = new Date(Date.now());
    assignmentDueDate.setHours(0, 0, 0, 0);
    assignmentDueDate.setDate(assignmentDueDate.getDate() + 1);
    return currentDateObject <= assignmentDueDate;
}


function EditEvaluationForm (props) {
    const {
        getClassStudents,
        evaluation,
        sprint,
        classStudents,
        resetEvaluationStatus,
        reviewingEvaluations,
        editEvaluation,
        authErrCode,
        history,
        assignment,
        user,
    } = props;

    const navigate = useNavigate();
    const [reviewedStudent, setReviewedStudent] = useState("");
    const [message, setMessage] = useState("");
    const [page, setPage] = useState("");
    const [loading, setLoading] = useState(false);
    const [questionAnswers, setQuestionAnswers] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);
        getClassStudents(evaluation.class);

        setReviewedStudent(evaluation.studentReviewed);

        const newQuestionAnswers = {}
        let questionAnswer;
        for (let i = 0; i < sprint?.questionAnswerTypePairs?.length; i++) {
            questionAnswer = evaluation.questionAnswerPairs[i];
            if (questionAnswer) {
                newQuestionAnswers[i + ":" + questionAnswer.question] = questionAnswer.answer;
            } else {
                newQuestionAnswers[i + ":" + sprint.questionAnswerTypePairs[i].question] = '';
            }
        }
        setQuestionAnswers({...questionAnswers, ...newQuestionAnswers})
    }, []);

    const getMappedQuestionsAnswerPairs = () => {
        return sprint.questionAnswerTypePairs &&
            sprint.questionAnswerTypePairs.map((questionAnswer, index) => {
                if (questionAnswer.answer === "Text") {
                    return (
                        <div className="evaluationQuestion" key={index + questionAnswer.question}>
                            <h2>{questionAnswer.question}</h2>
                            <div>
                                <TextField
                                    hintText="Answer"
                                    multiLine={true}
                                    rows={1}
                                    style={{width: "90%", maxWidth: "500px"}}
                                    name={index + ":" + questionAnswer.question}
                                    onChange={handleChange}
                                    value={questionAnswers[index + ":" + questionAnswer.question]}
                                />
                            </div>
                        </div>
                    )
                } else if (questionAnswer.answer === "Range") {
                    return (
                        <div className="evaluationQuestion" key={index + questionAnswer.question}>
                            <h2>{questionAnswer.question}</h2>
                            <div className="rangeResponse">
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="1"
                                            checked={questionAnswers[index + ":" + questionAnswer.question] === "1"}
                                        />
                                    1
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="2"
                                            checked={questionAnswers[index + ":" + questionAnswer.question] === "2"}
                                        />
                                    2
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="3"
                                            checked={questionAnswers[index + ":" + questionAnswer.question] === "3"}
                                        />
                                    3
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="4"
                                            checked={questionAnswers[index + ":" + questionAnswer.question] === "4"}
                                        />
                                    4
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="5"
                                            checked={questionAnswers[index + ":" + questionAnswer.question] === "5"}
                                        />
                                    5
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="6"
                                            checked={questionAnswers[index + ":" + questionAnswer.question] === "6"}
                                        />
                                    6
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="7"
                                            checked={questionAnswers[index + ":" + questionAnswer.question] === "7"}
                                        />
                                    7
                                    </label>
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div className="evaluationQuestion" key={index + questionAnswer.question}>
                            <h2>{questionAnswer.question}</h2>
                            <div className="rangeResponse">
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="Yes"
                                            checked={questionAnswers[index + ":" + questionAnswer.question] === "Yes"}
                                        />
                                        Yes
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="No"
                                            checked={questionAnswers[index + ":" + questionAnswer.question] === "No"}
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                    )
                }
            });
    }

    const getMappedStudents = () => {
        return classStudents !== undefined && classStudents
            .sort((a, b) => {
                if(a.lastName.toLowerCase() < b.lastName.toLowerCase()) return -1;
                if(a.lastName.toLowerCase() > b.lastName.toLowerCase()) return 1;
                return 0;
            })
            .map((student, index) => {
                return (
                    <MenuItem
                        key={index + student.firstName}
                        value={student.lastName + ", " + student.firstName}
                        primaryText={student.lastName + ", " + student.firstName}
                        id="reviewedStudent"
                        onClick={() => handleStudentDropdownChange(student._id)}
                    />
                )
            })
    }

    const handleChange = (e) => {
        setQuestionAnswers({...questionAnswers, [e.target.name]: e.target.value})
    }

    const handleStudentDropdownChange = (studentId) => {
        setReviewedStudent(studentId);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        resetEvaluationStatus();
        const questionAnswerPairs = []
        let entry;
        let pointsForReviewed = 0;
        let entrySplit;
        const createMatchingQuestionFinder = entrySplit => {
            return pair => pair.question === entrySplit[1];
        };
        let questionFinder;
        const state = {
            ...questionAnswers,
            reviewedStudent,
        }
        for (let key in state) {
            if (key === "reviewedStudent") {
                if (reviewedStudent === "") {
                    setMessage("You must answer all of the questions.");
                    setLoading(false);
                    return;
                }
            } else if (key !== "message" && key !== "loading" && key !== "page") {
                entrySplit = key.split(":");
                questionFinder = createMatchingQuestionFinder(entrySplit);
                if (entrySplit.length === 2) {
                    if (questionAnswers[key] === "") {
                        setMessage("You must answer all of the questions.");
                        setLoading(false);
                        return;
                    } else {
                        entry = sprint.questionAnswerTypePairs.find(questionFinder);
                        if (entry.answer === "Range") {
                            pointsForReviewed += parseInt(questionAnswers[key], 10)
                            questionAnswerPairs.push({question: key.split(":")[1], answer: questionAnswers[key], type: "Range"})
                        } else if (entry.answer === "Y/N") {
                            questionAnswerPairs.push({question: key.split(":")[1], answer: questionAnswers[key], type: "Y/N"})
                        } else {
                            questionAnswerPairs.push({question: key.split(":")[1], answer: questionAnswers[key], type: "Text"})
                        }
                    }
                }
            }
        }

        let status = evaluation.status;
        let isResubmission = status === "TeacherSubmittedReleased";
        if (isResubmission) {
            status = "StudentResubmitted";
        }

        const student = classStudents.find(student => student._id === reviewedStudent);
        editEvaluation(
            {
                questionAnswerPairs,
                pointsForReviewed,
                status,
                nameOfReviewedStudent: student.lastName + ", " + student.firstName,
                studentReviewed: reviewedStudent
            },
            evaluation._id,
            reviewingEvaluations
        );
        if (isResubmission) {
            setPage("student");
        } else {
            setPage("submitted");
        }
    }

    const handleDelete = (e) => {
        deleteEvaluation(
            evaluation._id,
            reviewingEvaluations
        );
        if (evaluation.status === "TeacherSubmittedReleased") {
            setPage("student");
        } else {
            setPage("submitted");
        }
    }

    const getStudentName = () => {
        const student = classStudents.find(student => student._id === reviewedStudent);
        return student ? student.lastName + ", " + student.firstName : "";
    }

    // A student can edit/delete their own freshly-submitted review while the
    // assignment portal is still open (before the local-midnight cutoff), even
    // when resubmissions are not enabled. After the portal closes, only a
    // teacher (or an explicit resubmission window) can change it.
    const canStudentEditOwn = user.type !== "teacher"
        && evaluation.status === "StudentSubmitted"
        && calculateIfOnTime(assignment.dueDate);
    const canEdit = user.type === "teacher" || assignment.allowResubmissions || canStudentEditOwn;

    let newLoading = loading;
    let newMessage = message;
    if (authErrCode.editEvals.status === 500) {
        newLoading = false;
        newMessage = "An error occurred, please try again. If the problem persists, save your answers in a separate file and try again later.";
    } else if (authErrCode.editEvals.status === 201) {
        // A teacher reaches this form from Manage Students -> Student Overview to
        // fix a recipient or delete a problematic review. The student-facing
        // redirect targets (/student, /student/submitted) are student-only
        // routes, so a teacher was being bounced to /teacher and never saw the
        // result, making edits/deletes appear to silently fail. Return teachers
        // to the Student Overview so the corrected data is visible in context.
        if (user.type === "teacher") {
            navigate("/student/overview");
        } else if (page === "student") {
            navigate("/student");
        } else {
            navigate("/student/submitted");
        }
    }

    return (
        <div className="evaluationForm">
            <div className="backButton">
                {
                  user.type === "teacher" ? (
                    <Link to="/manage/students">
                        <img src={require("../../../../Images/leftArrow.png")} alt="<-"/>
                        Return to Manage Students
                    </Link>
                  ) : evaluation.status === "TeacherSubmittedReleased" ?
                    <Link to="/student">
                        <img src={require("../../../../Images/leftArrow.png")} alt="<-"/>
                        Return to Dashboard
                    </Link>
                    :
                    <Link to="/student/submitted">
                        <img src={require("../../../../Images/leftArrow.png")} alt="<-"/>
                        Return to Submitted Reviews
                    </Link>
                }
            </div>
            <div style={{pointerEvents: canEdit ? "auto" : "none"}}>
                <h1>{assignment.name} Survey</h1>
                {(evaluation.status === "TeacherSubmittedReleased" || evaluation.status === "StudentResubmitted") &&
                    <div className="teacherFeedback">
                        <h2>Teacher Feedback</h2>
                        <h4>{evaluation.feedback}</h4>
                        <h2>Grade</h2>
                        <h4>{evaluation.teacherGrade}/3</h4>
                    </div>
                }
                {user.type === "teacher" ? (
                    <div>
                    <label className="teacherFeedback">(As a teacher, you can edit the evaluation for any student)</label>
                    <h2>Student who gave the review:</h2>
                    <p>{evaluation.nameOfReviewingStudent}</p>
                    <br />
                    </div>
                ):null}

                <h2>Student Being Reviewed</h2>
                {user.type === "teacher" ? (
                    <div>
                    <SelectField
                        name="reviewedStudent"
                        value={getStudentName()}
                        iconStyle={{paddingLeft: "22px"}}
                    >
                        {getMappedStudents()}
                    </SelectField>
                    </div>
                ) : evaluation.status !== "StudentSubmitted" ? (
                    <SelectField
                        name="reviewedStudent"
                        value={getStudentName()}
                        iconStyle={{paddingLeft: "22px"}}
                        disabled={true}
                    >
                        <MenuItem
                            value={getStudentName()}
                            primaryText={getStudentName()}
                            id="reviewedStudent"
                        />
                    </SelectField>
                ) : (
                    <SelectField
                        hintText={"Student"}
                        name="reviewedStudent"
                        value={getStudentName()}
                        iconStyle={{paddingLeft: "22px"}}
                    >
                        {getMappedStudents()}
                    </SelectField>
                )}
                {sprint?.questionAnswerTypePairs?.some(questionAnswerPair => questionAnswerPair.answer === "Range") &&
                    <h3>(For scale questions, 1=Strongly Disagree, 7=Strongly Agree)</h3>}
                {getMappedQuestionsAnswerPairs()}
                {evaluation.status !== "Released" && canEdit ? (
                    <StickyWrapper>
                        <div>
                            {
                                newLoading ?
                                    <img src={"/loading.svg"} alt="Loading..."/>
                                    :
                                    <div className="flex-row gap-4 justify-center">
                                        <div>
                                            <button className="actionButton" onClick={handleDelete}>
                                                Delete
                                            </button>
                                        </div>
                                        <div>
                                        <button style={{marginTop: "0"}} className="pink" onClick={handleSubmit}>Save</button>
                                        </div>
                                    </div>
                            }
                            <p>{newMessage}</p>
                        </div>
                    </StickyWrapper>
                ) : null}
            </div>
        </div>
    );
}

export default connect(state => state.root, { editEvaluation, getClassStudents, deleteEvaluation, resetEvaluationStatus })(EditEvaluationForm);
